module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxi"
    }
  }), _c('a', {
    attrs: {
      "id": "fm3"
    }
  }), _vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Caton")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Caton, “Review of Jacob Klein’s "), _c('em', [_vm._v("Greek Mathematical Thought and the Origin of Algebra")]), _vm._v("”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("CM")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("Cartesian Meditations")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Crisis")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("The Crisis of European Sciences and Transcendental Phenomenology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Early Writings")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("Early Writings in the Philosophy of Logic and Mathematics")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("EJ")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("Experience and Judgment")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Frege")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Frege, “Review of Dr. E. Husserl’s "), _c('em', [_vm._v("Philosophy of Arithmetic")]), _vm._v("”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("FTL")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("Formal and Transcendental Logic")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("GMTOA")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Klein, "), _c('em', [_vm._v("Greek Mathematical Thought and the Origin of Algebra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Ideas I")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("Ideas Pertaining to a Pure Phenomenology and to a Phenomenological Philosophy. First Book: General Introduction to a Pure Phenomenology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("ILI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, “Introduction to the "), _c('em', [_vm._v("Logical Investigations")]), _vm._v("” (1913)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("LI")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("Logical Investigations")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Origin")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, “The Origin of Geometry” (F = Fink’s edition; K = Biemel’s edition; C = Carr’s translation)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("PA")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("Philosophy of Arithmetic")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("PHS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Klein, “Phenomenology and the History of Science”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Prolegomena")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, "), _c('em', [_vm._v("Prolegomena to Pure Logic")]), _vm._v(", in "), _c('em', [_vm._v("LI")]), _vm._v(", vol. I")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("PRS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, “Philosophy as Rigorous Science”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Schröder")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, “Review of Ernst Schröder’s "), _c('em', [_vm._v("Vorlesungen über die Algebra der Logik")]), _vm._v("”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Semiotic")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, “On the Logic of Signs (Semiotic)”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Stumpf Letter")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Husserl, “Letter from Edmund Husserl to Carl Stumpf”")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("WP")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablea"
  }, [_vm._v("Klein, “The World of Physics and the ‘Natural’ World”"), _c('a', {
    attrs: {
      "id": "page_xxxii"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7565d044","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm3.vue
// module id = 81
// module chunks = 0